'use strict';

var _ = require('lodash');
var angular = require('angular');
var BusyIndicatorDirective = function BusyIndicatorDirective() {
  return {
    restrict: 'A',
    controller: 'BusyIndicatorController',
    link: function link(scope, element) {
      var overlay = angular.element(require('../templates/busy-indicator.html'));
      var keepModalUntilRelease;
      element.prepend(overlay);
      scope.showIndicator = function (keepItBy) {
        if (keepModalUntilRelease) {
          return;
        }
        if (_.isBoolean(keepItBy) && keepItBy && !keepModalUntilRelease) {
          keepModalUntilRelease = true;
        }
        overlay.addClass('active');
      };
      scope.hideIndicator = function (releasedBy) {
        if (_.isBoolean(releasedBy) && releasedBy && keepModalUntilRelease) {
          keepModalUntilRelease = false;
        }
        if (!keepModalUntilRelease) {
          overlay.removeClass('active');
        }
      };
    }
  };
};
BusyIndicatorDirective.$inject = [];
module.exports = BusyIndicatorDirective;